<template>
  <el-button type="primary" @click="handleCode">批量下载推广码</el-button>
</template>
<script lang="ts" setup>
import { getCurrentInstance } from "vue";
import instance from "@/api/request";
interface Props {
  param: any;
  url: string;
  method: string;
}
const props = withDefaults(defineProps<Props>(), {
  param: () => {
    return {};
  },
  url: "",
  method: "get",
});

const app = getCurrentInstance()?.proxy;

/**
 *  批量下载推广码
 */
const handleCode = () => {
  if (!props.param) {
    return app?.$message.error("请先选择用户");
  }
  const dt =
    props.method == "get"
      ? {
          params: props.param,
        }
      : props.param;
  instance[props.method](props.url, dt).then((res: any) => {
    // 创建a标签
    const fileName = "推广码.zip";
    const a = document.createElement("a");
    a.download = fileName;

    // 创建二进制对象
    const blob = new Blob([res], { type: "application/force-download" });
    const downloadURL = (window.URL || window.webkitURL).createObjectURL(blob);
    a.href = downloadURL;

    // 模拟点击
    a.click();

    //释放资源并删除创建的a标签
    URL.revokeObjectURL(downloadURL); // a.href
    document.body.removeChild(a);
  });
};
</script>
<style lang="scss" scoped></style>
